/**
 * API base URL.
 *
 * ResoluciÃ³n en orden:
 *  1) `VITE_API_URL` (env var de build, obligatoria en prod) â†’ Railway
 *     y cualquier entorno donde el front y el back viven en hosts distintos.
 *  2) Mismo hostname del front con port 3000 â†’ dev con subdominios
 *     (ej. `demo.localhost:5173` â†’ `http://demo.localhost:3000`).
 *  3) `http://localhost:3000` â†’ fallback SSR / tests.
 */
const API_PORT = 3000;

export function getApiBaseUrl() {
  // 1) Build-time env var (Vite sÃ³lo expone vars con prefijo VITE_)
  const fromEnv =
    typeof import.meta !== 'undefined' ? import.meta.env?.VITE_API_URL : undefined;
  if (fromEnv && typeof fromEnv === 'string' && fromEnv.length > 0) {
    return fromEnv.replace(/\/$/, '');
  }

  // 2) Dev: mismo host, port 3000
  if (typeof window === 'undefined') return `http://localhost:${API_PORT}`;
  const { hostname, protocol } = window.location;
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return `http://localhost:${API_PORT}`;
  }
  return `${protocol}//${hostname}:${API_PORT}`;
}

export const API_BASE_URL = getApiBaseUrl();
